// 西班牙语
export default {
  page_home: {
    mock_tit: "Profesor de inglés",
  },
};